import React, { useCallback, useState } from 'react';
import { Col, Row, Card, message } from 'antd';
import { token, lang, baseURL } from '../../api/config';
import '../../assets/iconfont.css';
import styles from './index.module.less';

const buildDownloadUrl = (series_id, key, isDeveloperTools) => {
  const baseUrl = `${baseURL}/api/plm/product/series/${series_id}/release-notes.md`;
  const params = new URLSearchParams({
    access_token: token,
    mode: 'inline',
    lang: lang,
  });

  if (isDeveloperTools) {
    params.append('category', 'DeveloperTools');
    params.append('subcategory', key);
  } else {
    params.append('category', 'firmware');
  }

  return `${baseUrl}?${params.toString()}`;
};

export default function ChangeLog({
  changelogs = [],
  isDeveloperTools = false,
  category,
  series_id,
}) {
  const [downloading, setDownloading] = useState({});

  const handleDownload = useCallback(async (key, value) => {
    if (downloading[key]) return;

    setDownloading(prev => ({ ...prev, [key]: true }));
    try {
      const response = await fetch(buildDownloadUrl(series_id, key, isDeveloperTools));
      if (!response.ok) throw new Error('Download failed');

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${value}_CHANGELOG.md`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      message.error('Failed to download changelog');
    } finally {
      setDownloading(prev => ({ ...prev, [key]: false }));
    }
  }, [series_id, isDeveloperTools]);

  return (
    <div className="singular-row">
      <Row gutter={[20, 20]}>
        {changelogs.map((changelogObject, index) => {
          const key = Object.keys(changelogObject)[0];
          const value = changelogObject[key];

          return (
            <Col key={index} span={6}>
              <Card className={downloading[key] ? styles.downloading : ''}>
                <div className="card-content">
                  <div className="card-content-left">
                    <div className={styles.file_title}>
                      {`${value}_CHANGELOG`}
                    </div>
                  </div>
                  <div className="download">
                    <i
                      className={`iconfont icon-download ${downloading[key] ? styles.disabled : ''}`}
                      onClick={() => handleDownload(key, value)}
                    />
                  </div>
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}
